import { MessageSquareText, HelpCircle, Layers, ClipboardCheck, NotebookPen, Target, Users } from "lucide-react";

export const Benefits = () => {
  const benefits = [
  {
    icon: MessageSquareText,
    title: "Chats"
  },
  {
    icon: HelpCircle,
    title: "Quizzes"
  },
  {
    icon: Layers,
    title: "Flashcards"
  },
  {
    icon: ClipboardCheck,
    title: "Exam Simulator"
  },
  {
    icon: NotebookPen,
    title: "Notes"
  },
  {
    icon: Target,
    title: "Progress Tracker"
  },
  {
    icon: Users,
    title: "Study Group"
  }];


  return (
    <section className="w-full py-24 px-6 md:px-10">
      <div className="container mx-auto max-w-[68.75rem] relative px-5">
        <div className="flex flex-col items-center justify-center gap-8">
          {/* Heading with decorative underline */}
          <div className="relative mb-12">
            <h2 className="text-4xl text-center text-foreground mt-5 mb-5 md:text-6xl font-medium">
              Focus starts
              <br />
              with{" "}
              <span className="relative inline-block">
                structure
                {/* Decorative SVG underline positioned under "structure" */}
                <span className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-[188px] hidden md:block">
                  <svg
                    width="188"
                    height="66"
                    viewBox="0 0 188 66"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-full h-auto">

                    <path
                      d="M154.529 9.6978C129.581 5.13136 98.5165 1.59123 73.9268 1.02158C54.3104 0.567134 4.23058 7.23925 1.10938 25.9273C-0.169054 33.5818 9.99662 39.9232 24.0528 47.5912C39.6924 56.1231 62.6498 59.0161 81.5764 60.8706C107.243 63.3854 131.618 64.1228 156.797 59.2747C174.075 55.9477 190.014 45.6453 186.514 32.5299C181.397 13.3508 109.751 7.40043 93.8118 6.40649C71.4915 5.01462 58.1796 5.82882 53.2096 6.61445C31.4031 10.0615 14.2834 20.5953 15.5557 36.849C16.4178 47.8627 36.5016 55.0027 48.7264 58.2876C78.1376 66.1909 128.561 68.8007 156.771 56.6986"
                      stroke="hsl(var(--chart-3))"
                      strokeWidth="2"
                      strokeLinecap="round"
                      fill="none" />

                  </svg>
                </span>
              </span>
            </h2>
          </div>

          {/* Benefits horizontal layout - no wrap on larger screens */}
          <div className="flex flex-wrap xl:flex-nowrap items-center justify-center gap-6 md:gap-8 lg:gap-10 xl:gap-12 w-full mt-4">
            {benefits.map((benefit, index) =>
            <div key={index} className="flex flex-col items-center justify-center gap-2 min-w-[80px]">
                <div className="w-8 h-8 flex items-center justify-center">
                  <benefit.icon className="w-8 h-8 stroke-foreground" strokeWidth={1.5} />
                </div>
                <div className="font-bold text-center text-foreground text-sm whitespace-nowrap">{benefit.title}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};